var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2788 17.75C14.4209 17.75 17.7788 14.3921 17.7788 10.25C17.7788 6.10786 14.4209 2.75 10.2788 2.75C6.13667 2.75 2.77881 6.10786 2.77881 10.25C2.77881 14.3921 6.13667 17.75 10.2788 17.75Z",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46631 11.1875C7.98408 11.1875 8.40381 10.7678 8.40381 10.25C8.40381 9.73223 7.98408 9.3125 7.46631 9.3125C6.94854 9.3125 6.52881 9.73223 6.52881 10.25C6.52881 10.7678 6.94854 11.1875 7.46631 11.1875Z",
    fill: "#3D464D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0913 11.1875C13.6091 11.1875 14.0288 10.7678 14.0288 10.25C14.0288 9.73223 13.6091 9.3125 13.0913 9.3125C12.5735 9.3125 12.1538 9.73223 12.1538 10.25C12.1538 10.7678 12.5735 11.1875 13.0913 11.1875Z",
    fill: "#3D464D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3491 13.375C11.7355 13.7825 11.0154 13.9999 10.2788 13.9999C9.54225 13.9999 8.82207 13.7825 8.2085 13.375",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2788 2.75C9.02881 4.3125 9.02881 5.875 9.02881 5.875C9.02881 6.20652 9.1605 6.52446 9.39493 6.75888C9.62935 6.9933 9.94729 7.125 10.2788 7.125C10.6103 7.125 10.9283 6.9933 11.1627 6.75888C11.3971 6.52446 11.5288 6.20652 11.5288 5.875",
    stroke: "#3D464D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby);
export default __webpack_public_path__ + "static/media/baby.a112b01fe7e914b2b225a89a7eea0f4e.svg";
export { ForwardRef as ReactComponent };